import { defineComponent as g, computed as v, ref as l, openBlock as c, createElementBlock as i, normalizeClass as d, toDisplayString as m, createCommentVNode as h, createElementVNode as b } from "vue";
import { _ as p } from "../../../_plugin-vue_export-helper-dad06003.js";
const u = (e) => {
  const r = f(e);
  return typeof r == "string" ? {
    color: void 0,
    path: r
  } : r;
}, f = (e) => {
  switch (e) {
    case "balcony":
      return "m/balcony.svg#balcony";
    case "diningroom-floor":
      return "m/diningroom-floor.svg#diningroom-floor";
    case "door-entry":
      return "m/door-entry.svg#door-entry";
    case "door-house":
      return "m/door-house.svg#door-house";
    case "door-inside":
      return "m/door-inside.svg#door-inside";
    case "garage":
      return "m/garage.svg#garage";
    case "hallway-floor":
      return "m/hallway-floor.svg#hallway-floor";
    case "illustration-bathroom-design":
      return "m/bathroom-design.svg#bathroom-design";
    case "illustration-fence":
      return "m/fence.svg#fence";
    case "illustration-front-yard":
      return "m/front-yard.svg#front-yard";
    case "illustration-garden-care-service":
      return "m/garden-care-service.svg#garden-care-service";
    case "illustration-livingroom-floor":
      return "m/livingroom-floor.svg#livingroom-floor";
    case "illustration-path":
      return "m/path.svg#path";
    case "illustration-pond":
      return "m/pond.svg#pond";
    case "illustration-raised-garden-bed":
      return "m/raised-garden-bed.svg#raised-garden-bed";
    case "illustration-renovation":
      return "m/renovation.svg#renovation";
    case "illustration-watering":
      return "m/watering.svg#watering";
    case "kitchen-floor":
      return "m/kitchen-floor.svg#kitchen-floor";
    case "new-bathroom":
      return "m/new-bathroom.svg#new-bathroom";
    case "nursery-floor":
      return "m/nursery-floor.svg#nursery-floor";
    case "refurbishing-house":
      return "m/refurbishing-house.svg#refurbishing-house";
    case "stairs":
      return "m/stairs.svg#stairs";
    case "window-roof":
      return "m/window-roof.svg#window-roof";
    case "window":
      return "m/window.svg#window";
    case "alert":
      return "alert.svg#alert";
    case "arrow-left":
      return "arrow-left.svg#arrow-left";
    case "attachment":
      return "attachment.svg#attachment";
    case "bath-bathtub":
      return "m/bathtub.svg#bathtub";
    case "bath-newbuild":
      return "m/new-bathroom.svg#new-bathroom";
    case "bath-other":
      return "m/bath-other.svg#bath-other";
    case "bath-renovation":
      return "m/complete-furnishing.svg#complete-furnishing";
    case "bath-shower":
      return "m/shower.svg#shower";
    case "bath-sink":
      return "m/sink.svg#sink";
    case "bath-still-open":
      return "m/bath-unknown.svg#bath-unknown";
    case "bath-wc":
      return "m/wc.svg#wc";
    case "bell--stroke":
      return "notification.svg#notification";
    case "bell":
      return "notification.svg#notification";
    case "benefits":
      return "l/bonuses.svg#bonuses";
    case "berater":
      return "expert.svg#expert";
    case "bookmark":
      return "save.svg#save";
    case "bottomcover":
      return "m/bottomcover.svg#bottomcover";
    case "calendar":
      return "calendar.svg#calendar";
    case "call-open-black":
      return "call-open.svg#call-open";
    case "cancel":
      return "cancel.svg#cancel";
    case "care-calendar-empty-state":
      return "l/careplan.svg#careplan";
    case "care-calendar":
      return "m/care-calendar.svg#care-calendar";
    case "careplan-error":
      return "l/error-careplan.svg#error-careplan";
    case "check-circle-outline":
      return "check-circle-outline.svg#check-circle-outline";
    case "checked-circle-orange":
      return {
        color: "#FF7E21",
        path: "check-circle-outline.svg#check-circle-outline"
      };
    case "checked-circle":
      return {
        color: "#00AB33",
        path: "check-circle-outline.svg#check-circle-outline"
      };
    case "checkmark-orange":
      return {
        color: "#FF7E21",
        path: "check-circle-filled.svg#check-circle-filled"
      };
    case "checkmark":
      return "check.svg#check";
    case "chevron-left":
      return "chevron-left.svg#chevron-left";
    case "close":
      return "close.svg#close";
    case "compare":
      return "compare.svg#compare";
    case "datepicker-calendar":
      return "calendar.svg#calendar";
    case "delete":
      return "l/delete.svg#delete";
    case "download-gray-600":
      return {
        path: "download.svg#download",
        color: "#757575"
      };
    case "edit":
      return "edit.svg#edit";
    case "eek-label-A":
      return "assets/eek-a.svg#eek-a";
    case "eek-label-B":
      return "assets/eek-b.svg#eek-b";
    case "eek-label-C":
      return "assets/eek-c.svg#eek-c";
    case "eek-label-D":
      return "assets/eek-d.svg#eek-d";
    case "eek-label-E":
      return "assets/eek-e.svg#eek-e";
    case "eek-label-F":
      return "assets/eek-f.svg#eek-f";
    case "eek-label-G":
      return "assets/eek-g.svg#eek-g";
    case "eek-label-old-A+++":
      return "assets/eek-old-a-plus-plus-plus.svg#eek-old-a-plus-plus-plus";
    case "eek-label-old-A++":
      return "assets/eek-old-a-plus-plus.svg#eek-old-a-plus-plus";
    case "eek-label-old-A+":
      return "assets/eek-old-a-plus.svg#eek-old-a-plus";
    case "eek-label-old-A":
      return "assets/eek-old-a.svg#eek-old-a";
    case "eek-label-old-B":
      return "assets/eek-old-b.svg#eek-old-b";
    case "eek-label-old-C":
      return "assets/eek-old-c.svg#eek-old-c";
    case "eek-label-old-D":
      return "assets/eek-old-d.svg#eek-old-d";
    case "eek-label-old-E":
      return "assets/eek-old-e.svg#eek-old-e";
    case "eek-label-old-F":
      return "assets/eek-old-f.svg#eek-old-f";
    case "eek-label-old-G":
      return "assets/eek-old-g.svg#eek-old-g";
    case "error-bonuses":
      return "l/error-bonuses.svg#error-bonuses";
    case "error-careplan":
      return "l/error-careplan.svg#error-careplan";
    case "error-construction":
      return "l/error.svg#error";
    case "error":
      return "close-circle-filled.svg#close-circle-filled";
    case "expert":
      return "expert.svg#expert";
    case "file":
      return "file.svg#file";
    case "freestanding":
      return "m/freestanding.svg#freestanding";
    case "gallery":
      return "image-gallery.svg#image-gallery";
    case "garden-boundary":
      return "m/gabion.svg#gabion";
    case "garden-carport":
      return "m/carport.svg#carport";
    case "garden-flowerbed":
      return "m/raised-garden-bed.svg#raised-garden-bed";
    case "garden-gettogether":
      return "m/bbq.svg#bbq";
    case "garden-greenhouse":
      return "m/growth-house.svg#growth-house";
    case "garden-other":
      return "m/garden-other.svg#garden-other";
    case "garden-pathorparking":
      return "m/path.svg#path";
    case "garden-pond":
      return "m/pond.svg#pond";
    case "garden-roofing":
      return "m/awning.svg#awning";
    case "garden-terraceorbalcony":
      return "m/terrace.svg#terrace";
    case "global-error":
      return {
        color: "#ededed",
        path: "close-circle-filled.svg#close-circle-filled"
      };
    case "hide":
      return "view-inactive.svg#view-inactive";
    case "illustration-appointment":
      return "l/appointment.svg#appointment";
    case "illustration-calendar-delete":
      return "l/info-appointment.svg#info-appointment";
    case "illustration-call":
      return "m/appointment.svg#appointment";
    case "illustration-document-upload-error":
      return "l/document-upload-error.svg#document-upload-error";
    case "illustration-error-appointment":
      return "l/error-appointment.svg#error-appointment";
    case "error-appointment":
      return "l/error-appointment.svg#error-appointment";
    case "illustration-error":
      return "l/error.svg#error";
    case "illustration-mail":
      return "m/mail.svg#mail";
    case "illustration-register":
      return "l/info-register.svg#info-register";
    case "illustration-send-message":
      return "l/message.svg#message";
    case "illustration-store":
      return "m/store.svg#store";
    case "illustration-success-appointment":
      return "l/success-appointment.svg#success-appointment";
    case "illustration-success-mail":
      return "l/success-message.svg#success-message";
    case "illustration-thumbsup":
      return "l/thumbsup.svg#thumbsup";
    case "illustration-warning":
      return "l/warning.svg#warning";
    case "inbox":
      return "inbox.svg#inbox";
    case "info-negative":
      return "alert-circle.svg#alert-circle";
    case "kitchen-form-i":
      return "m/form-1.svg#form-1";
    case "kitchen-form-l":
      return "m/form-1.svg#form-2";
    case "kitchen-form-u":
      return "m/form-1.svg#form-3";
    case "lawnrobot-installation":
      return "m/lawnrobot-installation.svg#lawnrobot-installation";
    case "lawnrobot-known":
      return "m/lawnrobot-known.svg#lawnrobot-known";
    case "lawnrobot-unknown":
      return "m/lawnrobot-unknown.svg#lawnrobot-unknown";
    case "lighting":
      return "m/lighting.svg#lighting";
    case "list":
      return "shopping-list.svg#shopping-list";
    case "location":
      return "location.svg#location";
    case "mail":
      return "mail.svg#mail";
    case "message-black":
      return "message.svg#message";
    case "minus":
      return "minus.svg#minus";
    case "nav-appointments":
      return "m/appointment.svg#appointment";
    case "nav-benefits":
      return "m/discount.svg#discount";
    case "nav-biber-bonus":
      return "m/biber-bonus.svg#biber-bonus";
    case "nav-care-calendar":
      return "m/care-calendar.svg#care-calendar";
    case "nav-customer-card":
      return "m/employee.svg#employee";
    case "nav-dashboard":
      return "m/customer-center-dashboard.svg#customer-center-dashboard";
    case "nav-new-inquiry":
      return "m/message.svg#message";
    case "nav-newsletter":
      return "m/newsletter.svg#newsletter";
    case "nav-note":
      return "m/notes.svg#notes";
    case "nav-online-shop":
      return "m/shopping-basket.svg#shopping-basket";
    case "nav-personal-data":
      return "m/setting.svg#setting";
    case "nav-shipping-address":
      return "m/delivery-address.svg#delivery-address";
    case "nav-store":
      return "m/store.svg#store";
    case "nolight":
      return "m/nolight.svg#nolight";
    case "obiMarketEditCard":
      return "store.svg#store";
    case "play-icon":
      return {
        color: "#FF7E21",
        path: "play.svg#play"
      };
    case "plus-circle-outline":
      return "plus-circle-outline.svg#plus-circle-outline";
    case "plus":
      return "plus.svg#plus";
    case "product-image":
      return "image-gallery.svg#image-gallery";
    case "profile":
      return "profile.svg#profile";
    case "purchases":
      return "l/shopping.svg#shopping";
    case "rating-star":
      return "rating-star.svg#rating-star";
    case "search-alt":
      return "search.svg#search";
    case "search-result-global":
      return "l/search-result-global.svg#search-result-global";
    case "search":
      return "search-result-global.svg#search-result-global";
    case "shopping-basket":
      return "shopping-basket.svg#shopping-basket";
    case "sidecover":
      return "m/sidecover.svg#sidecover";
    case "star-rounded-full":
      return "rating-star.svg#rating-star";
    case "star-rounded-half":
      return "rating-star-half.svg#rating-star-half";
    case "star":
      return "rating-star.svg#rating-star";
    case "store-black":
      return "store.svg#store";
    case "store":
      return "store.svg#store";
    case "success-careplan":
      return "l/success-careplan.svg#success-careplan";
    case "success-register":
      return "l/success-register.svg#success-register";
    case "success-vorteile":
      return "l/success-bonuses.svg#success-bonuses";
    case "success":
      return "check-circle-filled.svg#check-circle-filled";
    case "sunroof":
      return "m/sunroof.svg#sunroof";
    case "time-outline":
      return "time-outline.svg#time-outline";
    case "topcover":
      return "m/topcover.svg#topcover";
    case "trashbin-light":
      return "delete.svg#delete";
    case "view":
      return "view.svg#view";
    case "wallmount":
      return "m/wallmount.svg#wallmount";
    case "widget-calendar":
      return "calendar.svg#calendar";
    case "illustration-accessible-bathroom":
      return "m/accessible-bathroom.svg#accessible-bathroom";
    case "illustration-bbq":
      return "m/bbq.svg#bbq";
    case "illustration-carport":
      return "m/carport.svg#carport";
    case "illustration-heating":
      return "m/radiator.svg#radiator";
    case "illustration-lamp":
      return "m/lamp.svg#lamp";
    case "illustration-terrace":
      return "m/terrace.svg#terrace";
    case "illustration-wc":
      return "m/wc.svg#wc";
    case "bedroom-floor":
      return "m/bedroom-floor.svg#bedroom-floor";
    case "flat-roof":
      return "m/flat-roof.svg#flat-roof";
    case "house-owner":
      return "m/house-owner.svg#house-owner";
    case "house-rental":
      return "m/house-rental.svg#house-rental";
    case "pent-roof":
      return "m/pent-roof.svg#pent-roof";
    case "roof-angle-flat":
      return "m/roof-angle-flat.svg#roof-angle-flat";
    case "roof-angle-normal":
      return "m/roof-angle-normal.svg#roof-angle-normal";
    case "roof-angle-peak":
      return "m/roof-angle-peak.svg#roof-angle-peak";
    case "saddle-roof":
      return "m/saddle-roof.svg#saddle-roof";
    case "thumb-down":
      return "dislike.svg#dislike";
    case "thumb-up":
      return "like.svg#like";
    case "warning":
      return "l/warning.svg#warning";
    case "expired":
      return "l/warning.svg#warning";
    case "diy":
      return "m/diy.svg#diy";
    case "professionally-build":
      return "m/professionally-build.svg#professionally-build";
    case "half-half":
      return "m/half-half.svg#half-half";
  }
  return console.warn(
    "[VIcon]: Icon not found: " + e + " showing warning icon. This means either you are using an unknown name, or your are using symbol prop, where you should be using the url prop"
  ), "l/warning.svg#warning";
}, k = g({
  name: "VIcon",
  emits: ["click"],
  props: {
    symbol: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * If the role is 'img', use this to define an accessible title for the icon.
     * If not set, the symbol (file name) will be used as title.
     *
     */
    label: {
      type: String,
      default: ""
    },
    size: {
      type: [Number, String],
      default: 20
    },
    color: {
      type: String,
      default: "currentColor"
    },
    viewBox: {
      type: String
    },
    langCode: {
      type: String,
      default: "de"
    },
    baseUrl: {
      type: String,
      default: "/assets/icons/"
    },
    url: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * Role: Presentation = will be ignored by screen readers
     * Role: Img = will be read by screen readers. Set to img when the icon needs to convey meaning to the user
     *
     * If the role is presentation no title will be added, as won't be needed for a11y purposes.
     */
    role: {
      type: String,
      default: "presentation",
      validator(e) {
        return ["presentation", "img"].indexOf(e) !== -1;
      }
    },
    className: {
      type: String,
      required: !1
    }
  },
  setup: function(e) {
    const r = (t) => {
      const { path: n } = u(t);
      return n.includes("m/") ? "0 0 40 40" : n.includes("l/") ? "0 0 88 88" : n.includes("assets/") ? "0 0 80 80" : "0 0 24 24";
    }, o = v(() => e.viewBox ? e.viewBox : r(e.symbol)), s = l(""), a = l();
    if (e.symbol) {
      const { path: t, color: n } = u(e.symbol);
      return a.value = e.role === "img" ? e.symbol : void 0, s.value = e.label ? e.label : `${e.symbol} icon`, {
        viewBox: o,
        assetColor: n,
        ariaLabel: s,
        titleId: a,
        href: `${e.baseUrl}${t}`
      };
    } else {
      if (e.url)
        return a.value = e.role === "img" ? e.url : void 0, s.value = e.label ? e.label : `${e.url} icon`, {
          viewBox: o,
          assetColor: null,
          ariaLabel: s,
          titleId: a,
          href: `${e.baseUrl}${e.url}`
        };
      throw new Error("Either symbol or url must be set");
    }
  }
}), w = ["width", "height", "viewBox", "aria-labelledby", "role", "color"], y = ["id", "lang"], B = ["xlink:href"];
function C(e, r, o, s, a, t) {
  return c(), i("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: e.size,
    height: e.size,
    viewBox: e.viewBox,
    "aria-labelledby": e.titleId,
    role: e.role,
    color: e.assetColor || e.color,
    class: d(e.className || "hobi-icon")
  }, [
    e.role === "img" ? (c(), i("title", {
      key: 0,
      id: e.symbol,
      lang: e.langCode
    }, m(e.ariaLabel), 9, y)) : h("", !0),
    b("use", { "xlink:href": e.href }, null, 8, B)
  ], 10, w);
}
const E = /* @__PURE__ */ p(k, [["render", C]]);
export {
  E as default
};
